import React, { useEffect } from 'react';

import { TRACKONOMICS_CUSTOMER_ID } from 'constants/vendor';

export const SCRIPT_SRC =
  'https://cdn-magiclinks.trackonomics.net/client/static/v2/';

export const Trackonomics = () => {
  const loadScript = trackonomicsCustomerId => {
    const scrElement = document.createElement('script');

    scrElement.setAttribute('id', 'funnel-relay-installer');
    scrElement.setAttribute('data-customer-id', trackonomicsCustomerId);
    scrElement.setAttribute('data-property-id', 'PROPERTY_ID');
    scrElement.setAttribute('data-autorun', 'true');
    scrElement.setAttribute('async', 'true');
    scrElement.setAttribute('src', `${SCRIPT_SRC}${trackonomicsCustomerId}.js`);

    document.body.appendChild(scrElement);
  };

  useEffect(() => {
    if (!TRACKONOMICS_CUSTOMER_ID) {
      return;
    }

    if (!window.trx) {
      loadScript(TRACKONOMICS_CUSTOMER_ID);

      return;
    }

    window.trx.magicLinksEngine = new window.trx.MagicLinks(false);
    window.trx.magicLinksEngine.run(true);
  }, []);

  return null;
};

export default Trackonomics;
